// Google Analytics 4 event tracking for House Hunter

export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Pre-defined events for House Hunter interactions
export const analytics = {
  // Listing events
  listingAdd: () => trackEvent('listing_add'),
  listingEdit: (address) => trackEvent('listing_edit', { address }),
  listingDelete: (address) => trackEvent('listing_delete', { address }),
  listingStatusChange: (address, status) => trackEvent('listing_status_change', { address, status }),

  // Feature usage
  autoDetectElevation: (address, elevation) => trackEvent('auto_detect_elevation', { address, elevation }),
  urlFetch: (source) => trackEvent('url_fetch', { source }), // 'zillow' or 'redfin'
  importListings: (count) => trackEvent('import_listings', { count }),
  exportCSV: (count) => trackEvent('export_csv', { count }),

  // Tour
  tourStart: () => trackEvent('tour_start'),
  tourComplete: () => trackEvent('tour_complete'),
  tourSkip: (step) => trackEvent('tour_skip', { step }),

  // Filter/Sort
  filterChange: (filter) => trackEvent('filter_change', { filter }),
  sortChange: (sortBy) => trackEvent('sort_change', { sort_by: sortBy }),
};

export default analytics;
